/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { Document } from '../../core/models/Document';
import { OasOperation } from '../../openapi/models/OasOperation';
import { OasResponses } from '../../openapi/models/OasResponses';
import { DeleteNodeCommand } from './DeleteNodeCommand';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';

/**
 * @author eric.wittmann@gmail.com
 * @extends DeleteNodeCommand
 * @class
 */
export class DeleteAllResponsesCommand extends DeleteNodeCommand<OasResponses> {
    public constructor(property? : any, operation? : any) {
        if(((typeof property === 'string') || property === null) && ((operation != null && operation instanceof <any>OasOperation) || operation === null)) {
            let __args = arguments;
            super(property, operation);
        } else if(property === undefined && operation === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.DeleteNodeCommand#readNode(io.apicurio.datamodels.core.models.Document, java.lang.Object)
     * @param {Document} doc
     * @param {*} node
     * @return {OasResponses}
     */
    readNode(doc : Document, node : any) : OasResponses {
        let operation : OasOperation = <OasOperation>this._parentPath.resolve(doc);
        let responses : OasResponses = operation.createResponses();
        Library.readNode(node, responses);
        return responses;
    }
}
DeleteAllResponsesCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteAllResponsesCommand";
DeleteAllResponsesCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




